import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-calendar-navigation" }
const _hoisted_2 = { class: "h-flex h-flex-center h-width-100p" }
const _hoisted_3 = { class: "h-flex-dir-column h-flex h-width-100p" }
const _hoisted_4 = { class: "h-ph-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwMenu = _resolveComponent("FwMenu")!
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FwMenu, {
          type: "buttons",
          menuItems: _ctx.menu,
          activeId: _ctx.activeId,
          itemClass: "b-calendar-navigation__button",
          onClick: _ctx.changeCalendarTypeHandler
        }, null, 8, ["menuItems", "activeId", "onClick"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "b-calendar-navigation__button b-calendar-navigation__button--today",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeDayHandlerByToday(0)))
          }, [
            _createVNode(_component_FwIcon, {
              class: "h-mr-5",
              icon: "calendar",
              size: "10",
              color: "#203f6a"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('CALENDAR.BUTTON.TODAY')), 1)
          ])
        ])
      ])
    ])
  ]))
}